import CalendarButton from "./CalendarButton";
import { cartState } from "atoms";
import { useRecoilValue } from "recoil";
import "react-calendar/dist/Calendar.css";
import { SCHEDULE_TYPE_NON_SECURITY, SCHEDULE_TYPE_SECURITY } from "utils/const";

const ServiceAndInstallationButtonContainer: React.FC<{ appointments: any }> = ({ appointments }) => {
  const cart = useRecoilValue(cartState);
  return (
    <div className='service-installation-container'>
      <div className='customer-instruction-box'>
        {/* Displaying customer instructions */}
        <div>
          <strong>Choose a date and time for your installation. Please make sure someone over the age of 18 is present.</strong>
        </div>
        <small>*Installation times may vary based on the scope of work.</small>
      </div>

      {/* Rendering CalendarButton component for non-security appointments if available */}
      {appointments?.schedules?.nonSecuritySchedule?.availableAppointments.length > 0 ? (
        <CalendarButton
          appointments={appointments?.schedules?.nonSecuritySchedule?.availableAppointments}
          label='Select Date and Time'
          scheduleType={SCHEDULE_TYPE_NON_SECURITY}
        />
      ) : null}

      {/* Rendering CalendarButton component for security appointments if available */}
      {appointments?.schedules?.securitySchedule?.availableAppointments.length > 0 ? (
        <CalendarButton
          appointments={appointments?.schedules?.securitySchedule?.availableAppointments}
          label='Select Date and Time for Security Products'
          scheduleType={SCHEDULE_TYPE_SECURITY}
        />
      ) : null}
      {cart.schedule.multiGigInstallHelpTextLink ? (
        <div className='mt-3'>
          Please see important information about your installation{" "}
          <a href={cart.schedule.multiGigInstallHelpTextLink} target='_blank' rel='noreferrer'>
            here
          </a>
          .
        </div>
      ) : null}
    </div>
  );
};

export default ServiceAndInstallationButtonContainer;
